import { render, staticRenderFns } from "./show-videos.vue?vue&type=template&id=4a91b23d&"
import script from "./show-videos.vue?vue&type=script&lang=js&"
export * from "./show-videos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a91b23d')) {
      api.createRecord('4a91b23d', component.options)
    } else {
      api.reload('4a91b23d', component.options)
    }
    module.hot.accept("./show-videos.vue?vue&type=template&id=4a91b23d&", function () {
      api.rerender('4a91b23d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/show-videos.vue"
export default component.exports